import { For } from 'solid-js';
import { MODES } from '@domain/modes/modes';
import { modeStore, setCurrentMode } from '@state/modeStore';
import './ModeMenu.css';

export function ModeMenu() {
  return (
    <nav class="mode-menu" aria-label="Chess modes">
      <For each={MODES}>
        {(mode) => (
          <button
            type="button"
            class="mode-menu__item"
            classList={{ 'mode-menu__item--current': modeStore.current === mode.id }}
            aria-current={modeStore.current === mode.id ? 'page' : undefined}
            onClick={() => setCurrentMode(mode.id)}
          >
            {mode.label}
          </button>
        )}
      </For>
    </nav>
  );
}
